<template>
  <div class='black--text flex-wrap'>
    <div ref="rendered-content" class='rendered-content mr-2'>
      <div class="render-content" style='box-sizing: border-box' v-html='getRenderedContent(message.text)'></div>
      <div v-if="$isMobile && showSatisfaction && showFeedback" class="pb-2">
        <span class="mr-4" style="font-size: 13px; color: #0e700e">
          {{ 'chinese' === currentLanguage ? '以上方案是否已解决您的问题' : 'Has the current solution resolved your issue?' }}
        </span>
        <div class="mt-2">
          <v-btn
            class="mr-2"
            x-small
            :disabled="feedbackDisabled"
            :outlined="message.satisfactionFeedback !== '满意'"
            color="primary"
            @click="answerFeedback('满意')"
          >
          <span :style="getFeedbackButtonStyle()">
            {{ 'chinese' === currentLanguage ? '是' : 'Yes' }}
          </span>
          </v-btn>
          <v-btn
            x-small
            :disabled="feedbackDisabled"
            :outlined="message.satisfactionFeedback !== '不满意'"
            color="primary"
            @click="answerFeedback('不满意')"
            :loading="dissatisfiedLoading"
          >
        <span :style="getFeedbackButtonStyle()">
           {{ 'chinese' === currentLanguage ? '否（创建IT事件工单）' : 'No (Raise IT incident ticket)' }}</span>
          </v-btn>
        </div>
      </div>
    </div>
    <message-box
      :msg-id='message.msgId'
      class='mt-2'
      :message='message'
      :like-type='message.likeType'
      @refreshAnswer='refreshAnswer(message)'
      :showSatisfaction="showSatisfaction"
      :language="currentLanguage"
    ></message-box>
  </div>
</template>
<script>
import { markedRender } from '@/modules/chat/util/highlight'
import MessageBox from './MessageBox.vue'
import { getWorkOrderDesc, submitSatisfactionFeedback } from '@/modules/chat/api'
import { mapGetters } from 'vuex'
import { store } from '@/myops/core'

export default {
  components: {
    MessageBox,
  },
  props: {
    message: {
      type: Object,
      default: {},
    },
    language: {
      type: String,
      default: 'chinese',
    },
  },
  data() {
    return {
      eid: store.state.user.user.eid,
      showFeedback: process.env.VUE_APP_AI_ANSWER_FEEDBACK_ENABLED,
      dissatisfiedLoading: false,
      currentLanguage: 'chinese',
    }
  },
  computed: {
    ...mapGetters({
      chatSessionId: 'chat/chatSessionId',
      modelType: 'chat/modelType',
      SHOW_SATIS_EID: 'chat/SHOW_SATIS_EID',
    }),
    getRenderedContent() {
      return (content) => {
        return markedRender(content)
      }
    },
    showSatisfaction() {
      const has = this.message.hasOwnProperty('showSatisfaction')
      if (has) {
        return this.message.showSatisfaction
      }
      return true
    },
    feedbackDisabled() {
      return !!this.message.satisfactionFeedback
    },
  },
  mounted() {
    // 添加事件监听（在容器上监听所有链接点击）
    const container = this.$refs['rendered-content']
    container.addEventListener('click', this.handleContainerClick)
    this.currentLanguage = this.language
  },
  beforeDestroy() {
    // 移除事件监听
    this.$refs['rendered-content'].removeEventListener('click', this.handleContainerClick)
  },
  methods: {
    getFeedbackButtonStyle() {
      return { fontSize: '10px', color: this.feedbackDisabled ? '#7a7575' : '' }
    },
    refreshAnswer(message) {
      this.$emit('refreshAnswer', message)
    },
    // 事件处理函数
    handleContainerClick(e) {
      if (e.target.tagName === 'A') {
        e.preventDefault()
        window.open(e.target.href, '_blank')
      }
    },
    async answerFeedback(value) {
      if (this.message.satisfactionFeedback === value) {
        return
      }
      this.$set(this.message, 'satisfactionFeedback', value)
      submitSatisfactionFeedback({
        answerId: this.message.msgId,
        satisfactionFeedback: value,
        chatSessionId: this.chatSessionId,
      }).then(result => {
        if (value === '满意') {
          this.$bus.$emit('addMessage', {
            type: 'answerSatisfactionFeedbackEmit',
            value: value,
            title: this.message.queryContent,
            desc: this.message.text,
            language: this.currentLanguage,
          })
        }

      })
      if (value === '不满意') {
        this.dissatisfiedLoading = true
        getWorkOrderDesc({
          userQuery: this.message.queryContent,
          answer: this.message.text,
        }).then(result => {
          const resultData = result.data
          this.dissatisfiedLoading = false
          let isSuccessful = resultData.code === 200
          this.$bus.$emit('addMessage', {
            type: 'answerSatisfactionFeedbackEmit',
            value: value,
            language: this.currentLanguage,
            title: isSuccessful ? resultData.data.short_description : this.message.queryContent,
            desc: isSuccessful ? resultData.data.description : this.message.text,
          })
        })
      }
    },
  },
}
</script>
<style scoped>
.rendered-content {
  width: 734px;
  padding: 16px;
  background: #ffffff;
  text-align: left;
  font-family: Graphik, sans-serif;
  font-size: 16px;
  border: 2px solid #cccbce;
  border-radius: 4px 16px 16px 16px;
  filter: drop-shadow(0px 4px 8px rgba(193, 168, 200, .44));
}


::v-deep .render-content p {
  margin-bottom: 0 !important;
}

/* 移动端样式 */
@media (max-width: 767px) {
  .rendered-content {
    font-size: 14px;
    word-break: break-all;
    width: 95%;
  }
}
</style>
